import isIterable from '~/src/lib/isIterable';

export const getCartNbProducts = (cart) => {
    let nb = 0;

    if (isIterable(cart?.products)) {
        cart.products.forEach((item) => {
            nb = nb + item.quantity;
        });
    }

    return nb;
};

export default getCartNbProducts;
